'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = ModalHeader;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./modal-header.scss');

var _NavItem = require('../navItem/NavItem');

var _NavItem2 = _interopRequireDefault(_NavItem);

var _icon = require('../icon');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// components
var _ref = (0, _jsx3.default)(_icon.Icon, {
    name: 'x'
});
// css


/**
 * WH Modal Header Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>} HTML markup for the component
 */
function ModalHeader(props) {
    var _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        onClick = props.onClick,
        children = props.children,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id;


    var classNames = (0, _classnames2.default)((0, _defineProperty3.default)({
        'sb-modal__header': true
    }, '' + className, className));

    return (0, _jsx3.default)('header', {
        className: classNames,
        id: id
    }, void 0, (0, _jsx3.default)('section', {}, void 0, children), (0, _jsx3.default)(_NavItem2.default, {
        type: 'button',
        style: 'bare',
        onClick: onClick,
        className: 'sb-modal__close'
    }, void 0, _ref));
}
//# sourceMappingURL=ModalHeader.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/modal/ModalHeader.js
// module id = 582
// module chunks = 0